/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  var COLOR_DRAWER_PAGE_SIZE = 36;

  function disableBoldOnColorDrawerTemplate(root) {
    if (document.body && document.body.getAttribute('data-template-suffix') !== 'color-drawer') return;

    (root || document).querySelectorAll('.bold_options, .bold_clone').forEach(function (element) {
      element.remove();
    });

    (root || document).querySelectorAll('.product-form__add-button.bold_hidden').forEach(function (button) {
      button.classList.remove('bold_hidden');
      button.style.display = '';
    });
  }

  disableBoldOnColorDrawerTemplate();

  document.addEventListener('DOMContentLoaded', function () {
    disableBoldOnColorDrawerTemplate();
  });

  document.addEventListener('product:rerender', function (event) {
    disableBoldOnColorDrawerTemplate(event.target);
  }, true);

  if (window.MutationObserver && document.body && document.body.getAttribute('data-template-suffix') === 'color-drawer') {
    new MutationObserver(function (mutations) {
      if (document.body && document.body.getAttribute('data-template-suffix') !== 'color-drawer') return;

      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          disableBoldOnColorDrawerTemplate(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function getPickerFromDrawer(drawer) {
    return drawer ? drawer.__colorPicker || drawer.closest('[data-color-picker]') : null;
  }

  function moveDrawerToBody(drawer) {
    if (!drawer || drawer.parentNode === document.body) return;

    drawer.__colorDrawerPlaceholder = document.createComment('color drawer placeholder');
    drawer.parentNode.insertBefore(drawer.__colorDrawerPlaceholder, drawer);
    document.body.appendChild(drawer);
  }

  function restoreDrawerPosition(drawer) {
    var placeholder = drawer && drawer.__colorDrawerPlaceholder;
    if (!placeholder || !placeholder.parentNode) return;

    placeholder.parentNode.insertBefore(drawer, placeholder);
    placeholder.parentNode.removeChild(placeholder);
    drawer.__colorDrawerPlaceholder = null;
  }

  function getDrawerTitleEl(drawer) {
    return drawer.querySelector('.color-selector-drawer__title');
  }

  function showDrawerView(drawer, viewName) {
    drawer.querySelectorAll('[data-color-drawer-view]').forEach(function (view) {
      view.classList.toggle('is-active', view.getAttribute('data-color-drawer-view') === viewName);
    });

    var body = drawer.querySelector('.color-selector-drawer__body');
    if (body) body.scrollTop = 0;

    var backButton = drawer.querySelector('[data-color-drawer-back]');
    if (backButton) backButton.hidden = viewName !== 'detail';

    if (viewName !== 'detail') {
      var titleEl = getDrawerTitleEl(drawer);
      if (titleEl && drawer.__defaultDrawerTitle !== undefined) {
        titleEl.textContent = drawer.__defaultDrawerTitle;
      }
    }
  }

  function getVisibleColorLimit(drawer) {
    return parseInt(drawer.getAttribute('data-color-visible-limit') || COLOR_DRAWER_PAGE_SIZE, 10);
  }

  function renderVisibleColors(drawer) {
    if (drawer.querySelector('[data-color-families]')) {
      drawer.querySelectorAll('[data-color-tile]').forEach(function (tile) { tile.hidden = false; });
      return;
    }
    var category = drawer.getAttribute('data-color-current-category') || 'all';
    var limit = getVisibleColorLimit(drawer);
    var matchingTiles = [];

    drawer.querySelectorAll('[data-color-tile]').forEach(function (tile) {
      var categories = tile.getAttribute('data-categories') || '';
      var matchesCategory = category === 'all' || categories.split(/\s+/).indexOf(category) !== -1;

      tile.hidden = true;
      if (matchesCategory) matchingTiles.push(tile);
    });

    matchingTiles.slice(0, limit).forEach(function (tile) {
      tile.hidden = false;
    });

    var loadMore = drawer.querySelector('[data-color-load-more]');
    if (loadMore) loadMore.hidden = matchingTiles.length <= limit;
  }

  function setColorFamily(drawer, family, resetScroll) {
    var families = drawer.querySelector('[data-color-families]');
    if (!families) return;
    families.querySelectorAll('[data-color-family-button]').forEach(function (button) {
      button.setAttribute('aria-expanded', String(button.getAttribute('data-color-family-button') === family));
    });
    families.querySelectorAll('[data-color-family-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-color-family-panel') !== family;
    });
    if (resetScroll) {
      var body = drawer.querySelector('.color-selector-drawer__body');
      if (body) body.scrollTop = 0;
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-color-family-button]');
    if (!button) return;
    var drawer = button.closest('[data-color-drawer]');
    if (!drawer) return;
    var family = button.getAttribute('aria-expanded') === 'true' ? '' : button.getAttribute('data-color-family-button');
    setColorFamily(drawer, family, true);
  });

  function resetColorGrid(drawer, category) {
    drawer.setAttribute('data-color-current-category', category || 'all');
    drawer.setAttribute('data-color-visible-limit', COLOR_DRAWER_PAGE_SIZE);
    renderVisibleColors(drawer);
  }

  var openDrawerCount = 0;
  var activeColorDrawer = null;

  function focusDrawerControl(drawer) {
    var control = drawer.querySelector('[data-color-drawer-close]');
    if (control) control.focus({ preventScroll: true });
  }

  document.addEventListener('keydown', function (event) {
    if (!activeColorDrawer) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      closeDrawer(activeColorDrawer);
      return;
    }
    if (event.key !== 'Tab') return;
    var controls = Array.prototype.filter.call(activeColorDrawer.querySelectorAll(
      'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]'
    ), function (el) { return !el.closest('[hidden]') && el.getClientRects().length > 0; });
    var first = controls[0];
    var last = controls[controls.length - 1];
    if (!first) { event.preventDefault(); return; }
    if (!activeColorDrawer.contains(document.activeElement) || (event.shiftKey && document.activeElement === first)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('focusin', function (event) {
    if (activeColorDrawer && !activeColorDrawer.contains(event.target)) focusDrawerControl(activeColorDrawer);
  });

  function isInsideOpenDrawer(target) {
    var openDrawers = document.querySelectorAll('.color-selector-drawer[aria-hidden="false"]');
    for (var i = 0; i < openDrawers.length; i++) {
      if (openDrawers[i].contains(target)) return true;
    }
    return false;
  }

  function preventBackgroundScrollKeys(event) {
    var scrollKeys = ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '];
    if (scrollKeys.indexOf(event.key) === -1) return;
    if (isInsideOpenDrawer(event.target)) return;
    event.preventDefault();
  }

  function lockBackgroundScroll() {
    document.addEventListener('keydown', preventBackgroundScrollKeys, false);

    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarWidth > 0) {
      document.documentElement.style.setProperty('--color-drawer-scrollbar-width', scrollbarWidth + 'px');
    }
    document.documentElement.classList.add('color-drawer-open');
  }

  function unlockBackgroundScroll() {
    document.removeEventListener('keydown', preventBackgroundScrollKeys, false);
    document.documentElement.classList.remove('color-drawer-open');
    document.documentElement.style.removeProperty('--color-drawer-scrollbar-width');
  }

  function sizeColorMainImage(img, ratio) {
    var frame = img.closest('[data-color-image-frame]');
    var width = frame ? frame.clientWidth : 0;
    var height = frame ? frame.clientHeight : 0;
    ratio = parseFloat(ratio) || (img.width / img.height) || 1;
    if (width > 0) img.sizes = Math.ceil(Math.min(width, height > 0 ? height * ratio : width)) + 'px';
    img.width = 960;
    img.height = Math.round(960 / ratio);
  }

  function hydrateLazyImages(scope) {
    scope.querySelectorAll('img[data-src]').forEach(function (img) {
      var fullSrc = img.getAttribute('data-src');
      var fullSrcset = img.getAttribute('data-srcset');
      if (img.hasAttribute('data-color-main-image')) {
        sizeColorMainImage(img);
        img.loading = 'eager';
        img.setAttribute('fetchpriority', 'high');
      }
      if (fullSrcset) img.srcset = fullSrcset;
      img.src = fullSrc;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-placeholder');
      img.classList.remove('is-placeholder');
    });
  }

  var prefetchedMainImages = {};

  function prefetchColorMainImage(tile) {
    var detailId = tile.getAttribute('data-detail-id');
    if (!detailId || prefetchedMainImages[detailId]) return;

    var detail = document.getElementById(detailId);
    var mainImage = detail ? detail.querySelector('[data-color-main-image]') : null;
    var fullSrc = mainImage ? mainImage.getAttribute('data-src') : null;
    if (!fullSrc) return;

    var fullSrcset = mainImage.getAttribute('data-srcset');
    var img = new Image();
    img.sizes = mainImage.getAttribute('sizes') || '(max-width: 640px) calc(100vw - 42px), 598px';
    img.fetchPriority = 'low';
    if (fullSrcset) img.srcset = fullSrcset;
    img.src = fullSrc;
    prefetchedMainImages[detailId] = img;
  }

  document.addEventListener('pointerover', function (event) {
    if (event.pointerType !== 'mouse') return;
    var tile = event.target.closest('[data-color-drawer-show-detail]');
    if (tile) prefetchColorMainImage(tile);
  });

  document.addEventListener('focusin', function (event) {
    var tile = event.target.closest && event.target.closest('[data-color-drawer-show-detail]');
    if (tile) prefetchColorMainImage(tile);
  });

  function prepareDetailForDrawer(drawer, detailView) {
    var browseOnly = drawer.hasAttribute('data-browse-only');
    var showSurcharge = drawer.hasAttribute('data-show-surcharge');
    var selectButton = detailView.querySelector('[data-color-select]');

    if (selectButton) {
      if (browseOnly) {
        selectButton.remove();
      } else {
        selectButton.setAttribute('data-controls', drawer.getAttribute('data-controls-id') || '');
        var label = selectButton.querySelector('[data-color-select-label]');
        if (label) label.textContent = drawer.getAttribute('data-select-label') || 'Use This Color';
        if (!showSurcharge) selectButton.removeAttribute('data-price-variant-id');
      }
    }

    if (!showSurcharge) {
      detailView.querySelectorAll('[data-color-surcharge]').forEach(function (el) { el.remove(); });
    }
  }

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function initThumbScroller(container) {
    var list = container.querySelector('[data-color-thumb-list]');
    if (!list || container.__colorThumbScrollerInit) return;
    container.__colorThumbScrollerInit = true;
    var windowListeners = [];
    function listenWindow(type, listener, options) {
      window.addEventListener(type, listener, options);
      windowListeners.push([type, listener, options]);
    }
    container.__colorThumbScrollerCleanup = function () {
      windowListeners.forEach(function (args) { window.removeEventListener(args[0], args[1], args[2]); });
      windowListeners = [];
      cancelAnimationFrame(frameId);
    };

    var btnLeft = document.createElement('button');
    btnLeft.type = 'button';
    btnLeft.className = 'color-thumb-scroll-btn color-thumb-scroll-btn--left';
    btnLeft.setAttribute('aria-label', 'Scroll thumbnails left');
    btnLeft.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path></svg>';
    var btnRight = document.createElement('button');
    btnRight.type = 'button';
    btnRight.className = 'color-thumb-scroll-btn color-thumb-scroll-btn--right';
    btnRight.setAttribute('aria-label', 'Scroll thumbnails right');
    btnRight.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8.59 16.59 10 18l6-6-6-6-1.41 1.41L13.17 12z"></path></svg>';
    container.appendChild(btnLeft);
    container.appendChild(btnRight);

    var bar = document.createElement('div');
    bar.className = 'color-thumb-scrollbar';
    var thumbEl = document.createElement('div');
    thumbEl.className = 'color-thumb-scrollbar__thumb';
    bar.appendChild(thumbEl);
    container.appendChild(bar);

    function sizes() {
      var trackW = bar.clientWidth;
      var scrollW = list.scrollWidth;
      var clientW = list.clientWidth;
      var ratio = clientW / scrollW;
      var thumbW = clamp(Math.round(trackW * ratio), 30, trackW);
      var maxThumbLeft = Math.max(0, trackW - thumbW);
      var maxScroll = Math.max(0, scrollW - clientW);
      return { trackW: trackW, maxThumbLeft: maxThumbLeft, maxScroll: maxScroll, thumbW: thumbW };
    }

    function syncThumb() {
      var s = sizes();
      container.classList.toggle('has-thumbs-left', list.scrollLeft > 2);
      container.classList.toggle('has-thumbs-right', list.scrollLeft < s.maxScroll - 2);
      btnLeft.disabled = list.scrollLeft <= 2;
      btnRight.disabled = list.scrollLeft >= s.maxScroll - 2;
      thumbEl.style.width = s.thumbW + 'px';
      if (s.maxScroll <= 0) {
        bar.hidden = true;
        btnLeft.hidden = true;
        btnRight.hidden = true;
        return;
      }
      bar.hidden = false;
      btnLeft.hidden = false;
      btnRight.hidden = false;
      var pct = list.scrollLeft / s.maxScroll;
      thumbEl.style.left = Math.round(s.maxThumbLeft * pct) + 'px';
    }

    function step() {
      return Math.max(120, Math.floor(list.clientWidth * 0.8));
    }

    btnLeft.addEventListener('click', function (e) {
      e.preventDefault();
      list.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    btnRight.addEventListener('click', function (e) {
      e.preventDefault();
      list.scrollBy({ left: step(), behavior: 'smooth' });
    });

    function scheduleThumbSync() {
      if (frameId) return;
      frameId = requestAnimationFrame(function () {
        frameId = 0;
        syncThumb();
      });
    }
    list.addEventListener('scroll', scheduleThumbSync, { passive: true });
    listenWindow('resize', scheduleThumbSync, { passive: true });

    var listDragging = false;
    var listStartX = 0;
    var listStartScroll = 0;
    var listMoved = false;
    var dragEndAt = 0;
    list.addEventListener('pointerdown', function (e) {
      dragEndAt = 0;
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (!list.scrollWidth || list.scrollWidth <= list.clientWidth) return;
      listDragging = true;
      listMoved = false;
      listStartX = e.clientX;
      listStartScroll = list.scrollLeft;
      list.classList.remove('se-dragging');
    });
    list.addEventListener('dragstart', function (e) { e.preventDefault(); });
    listenWindow('pointermove', function (e) {
      if (!listDragging) return;
      var dx = e.clientX - listStartX;
      if (!listMoved && Math.abs(dx) > 4) {
        listMoved = true;
        list.classList.add('se-dragging');
      }
      if (!listMoved) return;
      list.scrollLeft = listStartScroll - dx;
      e.preventDefault();
    }, { passive: false });
    listenWindow('pointerup', function () {
      if (!listDragging) return;
      listDragging = false;
      dragEndAt = listMoved ? Date.now() : 0;
      list.classList.remove('se-dragging');
    });
    list.addEventListener('click', function (e) {
      if (dragEndAt && (Date.now() - dragEndAt) < 250) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    var dragging = false;
    var startX = 0;
    var startLeft = 0;
    thumbEl.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      dragging = true;
      thumbEl.classList.add('is-dragging');
      startX = e.clientX;
      startLeft = parseInt(thumbEl.style.left || '0', 10) || 0;
      e.preventDefault();
    });
    listenWindow('pointermove', function (e) {
      if (!dragging) return;
      var s = sizes();
      if (s.maxScroll <= 0) return;
      var newLeft = clamp(startLeft + (e.clientX - startX), 0, s.maxThumbLeft);
      var pct = s.maxThumbLeft ? (newLeft / s.maxThumbLeft) : 0;
      list.scrollLeft = Math.round(s.maxScroll * pct);
      e.preventDefault();
    }, { passive: false });
    listenWindow('pointerup', function () {
      if (!dragging) return;
      dragging = false;
      thumbEl.classList.remove('is-dragging');
    });

    listenWindow('pointercancel', function () {
      listDragging = false;
      dragging = false;
      list.classList.remove('se-dragging');
      thumbEl.classList.remove('is-dragging');
    });
    var frameId = 0;
    scheduleThumbSync();
  }

  function initThumbScrollers(root) {
    root.querySelectorAll('[data-color-thumb-scroller]').forEach(initThumbScroller);
  }

  function cleanupDrawerMedia(drawer) {
    if (!drawer) return;
    drawer.querySelectorAll('[data-color-viewer]').forEach(stopViewerVideo);
    drawer.querySelectorAll('[data-color-thumb-scroller]').forEach(function (container) {
      if (container.__colorThumbScrollerCleanup) container.__colorThumbScrollerCleanup();
    });
  }

  function markSelectedThumb(detail, selected) {
    detail.querySelectorAll('[data-color-detail-thumb], [data-color-video-thumb]').forEach(function (thumb) {
      thumb.setAttribute('aria-pressed', String(thumb === selected));
    });
  }

  function showColorDetail(drawer, detailId) {
    var detail = document.getElementById(detailId);
    var detailView = drawer ? drawer.querySelector('[data-color-drawer-view="detail"]') : null;
    if (!drawer || !detail || !detailView) return false;

    var body = drawer.querySelector('.color-selector-drawer__body');
    drawer.__colorGridScroll = body ? body.scrollTop : 0;
    cleanupDrawerMedia(drawer);
    drawer.__lastDetailId = detailId;
    detailView.innerHTML = detail.innerHTML;
    showDrawerView(drawer, 'detail');

    var titleEl = getDrawerTitleEl(drawer);
    var colorName = detail.getAttribute('data-color-name');
    if (titleEl && colorName) titleEl.textContent = colorName;

    var description = detailView.querySelector('.color-selector-detail__description');
    var firstHeading = description && description.firstElementChild;
    if (firstHeading && /^H[1-6]$/.test(firstHeading.tagName) && firstHeading.textContent.trim().toLowerCase() === (colorName || '').trim().toLowerCase()) firstHeading.remove();
    var duplicateTitle = detailView.querySelector('.color-selector-detail__title');
    if (duplicateTitle && duplicateTitle.textContent.trim() === colorName) duplicateTitle.remove();
    markSelectedThumb(detailView, detailView.querySelector('[data-color-detail-thumb]'));
    prepareDetailForDrawer(drawer, detailView);
    hydrateLazyImages(detailView);
    initColorDescriptionToggle(detailView);
    initThumbScrollers(detailView);
    return true;
  }

  function openDrawer(drawer, opener) {
    if (activeColorDrawer === drawer) return;
    if (activeColorDrawer) closeDrawer(activeColorDrawer);
    activeColorDrawer = drawer;
    drawer.__colorDrawerOpener = opener || document.activeElement;
    var picker = opener ? opener.closest('[data-color-picker]') : getPickerFromDrawer(drawer);
    drawer.__colorPicker = picker;
    moveDrawerToBody(drawer);
    drawer.setAttribute('aria-hidden', 'false');
    if (opener) opener.setAttribute('aria-expanded', 'true');
    focusDrawerControl(drawer);

    if (drawer.__defaultDrawerTitle === undefined) {
      var titleEl = getDrawerTitleEl(drawer);
      drawer.__defaultDrawerTitle = titleEl ? titleEl.textContent : '';
    }

    if (openDrawerCount === 0) {
      lockBackgroundScroll();
    }
    openDrawerCount += 1;
    drawer.dispatchEvent(new CustomEvent('em:reset-color-filter', { bubbles: true }));
    resetColorGrid(drawer, 'all');

    var isCtaOpener = !!(opener && opener.classList.contains('color-picker-summary--cta'));
    var input = picker ? picker.querySelector('input[type="hidden"]') : null;
    var selectedValue = input ? input.value : '';
    var selectedTile = selectedValue ? drawer.querySelector('[data-color-tile][data-value="' + CSS.escape(selectedValue) + '"]') : null;

    var families = drawer.querySelector('[data-color-families]');
    if (families) {
      var selectedFamily = selectedTile ? selectedTile.closest('[data-color-family-panel]') : null;
      showDrawerView(drawer, 'colors');
      setColorFamily(drawer, selectedFamily ? selectedFamily.getAttribute('data-color-family-panel') : families.getAttribute('data-color-default-family'), true);
      return;
    }

    if (!isCtaOpener && selectedTile && showColorDetail(drawer, selectedTile.getAttribute('data-detail-id'))) {
      return;
    }

    var hasCategories = !!drawer.querySelector('[data-color-drawer-show-colors]');
    showDrawerView(drawer, hasCategories ? 'categories' : 'colors');
  }

  function closeDrawer(drawer, restoreFocus) {
    if (!drawer || drawer.getAttribute('aria-hidden') !== 'false') return;
    cleanupDrawerMedia(drawer);
    if (activeColorDrawer === drawer) activeColorDrawer = null;
    var picker = getPickerFromDrawer(drawer);
    var opener = drawer.__colorDrawerOpener || (picker ? picker.querySelector('[data-color-drawer-open]') : null);

    drawer.setAttribute('aria-hidden', 'true');
    if (opener) opener.setAttribute('aria-expanded', 'false');

    openDrawerCount = Math.max(0, openDrawerCount - 1);
    if (openDrawerCount === 0) {
      unlockBackgroundScroll();
    }
    restoreDrawerPosition(drawer);
    if (restoreFocus !== false && opener && opener.isConnected) opener.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-color-drawer-open]');
    if (!opener) return;

    var drawer = document.getElementById(opener.getAttribute('aria-controls'));
    if (!drawer) return;

    event.preventDefault();
    openDrawer(drawer, opener);
  });

  document.addEventListener('click', function (event) {
    var closeButton = event.target.closest('[data-color-drawer-close]');
    var drawer = closeButton ? closeButton.closest('[data-color-drawer]') : null;
    if (!drawer) return;

    event.preventDefault();
    closeDrawer(drawer);
  });

  document.addEventListener('click', function (event) {
    var drawer = event.target.matches('[data-color-drawer]') ? event.target : null;
    if (!drawer) return;

    closeDrawer(drawer);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-color-drawer-show-colors]');
    if (!button) return;

    var drawer = button.closest('[data-color-drawer]');
    var category = button.getAttribute('data-category');
    if (!drawer || !category) return;

    resetColorGrid(drawer, category);
    showDrawerView(drawer, 'colors');
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-color-load-more]');
    if (!button) return;

    var drawer = button.closest('[data-color-drawer]');
    if (!drawer) return;

    var nextLimit = getVisibleColorLimit(drawer) + COLOR_DRAWER_PAGE_SIZE;
    drawer.setAttribute('data-color-visible-limit', nextLimit);
    renderVisibleColors(drawer);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-color-drawer-show-detail]');
    if (!button) return;

    var drawer = button.closest('[data-color-drawer]');
    if (showColorDetail(drawer, button.getAttribute('data-detail-id'))) {
      var backButton = drawer.querySelector('[data-color-drawer-back]');
      if (backButton) backButton.focus({ preventScroll: true });
    }
  });

  function initColorDescriptionToggle(scope) {
    var wrap = scope.querySelector('[data-color-description]');
    if (!wrap) return;

    var toggle = wrap.querySelector('[data-color-description-toggle]');
    if (!toggle) return;

    wrap.classList.remove('is-expanded');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.hidden = wrap.scrollHeight <= wrap.clientHeight;
  }

  function setVideoEmbedAspectRatio(viewer, aspectRatio) {
    var videoEmbed = viewer ? viewer.querySelector('[data-color-video-embed]') : null;
    if (!videoEmbed) return;

    var ratio = parseFloat(aspectRatio) || (16 / 9);
    videoEmbed.style.aspectRatio = ratio;
  }

  function stopViewerVideo(viewer) {
    var videoEmbed = viewer ? viewer.querySelector('[data-color-video-embed]') : null;
    if (!videoEmbed) return;

    videoEmbed.hidden = true;
    videoEmbed.innerHTML = '';
  }

  document.addEventListener('click', function (event) {
    var thumbButton = event.target.closest('[data-color-detail-thumb]');
    if (!thumbButton) return;

    var detail = thumbButton.closest('[data-color-drawer-view="detail"]');
    var viewer = detail ? detail.querySelector('[data-color-viewer]') : null;
    var mainImage = viewer ? viewer.querySelector('[data-color-main-image]') : null;
    var fullImage = thumbButton.getAttribute('data-full-image');
    var fullImageSrcset = thumbButton.getAttribute('data-full-srcset');
    if (!mainImage || !fullImage) return;

    mainImage.hidden = false;
    stopViewerVideo(viewer);
    markSelectedThumb(detail, thumbButton);

    sizeColorMainImage(mainImage, thumbButton.getAttribute('data-aspect-ratio'));
    mainImage.classList.remove('is-placeholder');
    mainImage.srcset = fullImageSrcset || '';
    mainImage.src = fullImage;
  });

  document.addEventListener('click', function (event) {
    var thumbButton = event.target.closest('[data-color-video-thumb]');
    if (!thumbButton) return;

    var detail = thumbButton.closest('[data-color-drawer-view="detail"]');
    var viewer = detail ? detail.querySelector('[data-color-viewer]') : null;
    var template = thumbButton.querySelector('[data-color-video-template]');
    var videoEmbed = viewer ? viewer.querySelector('[data-color-video-embed]') : null;
    var mainImage = viewer ? viewer.querySelector('[data-color-main-image]') : null;
    if (!template || !videoEmbed) return;

    stopViewerVideo(viewer);
    markSelectedThumb(detail, thumbButton);
    videoEmbed.appendChild(template.content.cloneNode(true));
    videoEmbed.hidden = false;
    if (mainImage) mainImage.hidden = true;
    setVideoEmbedAspectRatio(viewer, thumbButton.getAttribute('data-aspect-ratio'));
  });

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-color-description-toggle]');
    if (!toggle) return;

    var wrap = toggle.closest('[data-color-description]');
    if (!wrap) return;

    var expanded = wrap.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', String(expanded));
    var text = toggle.querySelector('span');
    if (text) text.textContent = expanded ? text.getAttribute('data-view-less') : text.getAttribute('data-view-more');
  });

  document.addEventListener('click', function (event) {
    var backButton = event.target.closest('[data-color-drawer-back]');
    if (!backButton) return;

    var drawer = backButton.closest('[data-color-drawer]');
    if (!drawer) return;

    var detailView = drawer.querySelector('[data-color-drawer-view="detail"]');
    if (detailView && detailView.classList.contains('is-active')) {
      cleanupDrawerMedia(drawer);
      showDrawerView(drawer, 'colors');
      var lastTile = drawer.querySelector('[data-color-tile][data-detail-id="' + CSS.escape(drawer.__lastDetailId || '') + '"]');
      if (drawer.querySelector('[data-color-families]')) {
        var body = drawer.querySelector('.color-selector-drawer__body');
        if (body) body.scrollTop = drawer.__colorGridScroll || 0;
        if (lastTile) lastTile.focus({ preventScroll: true });
      } else if (lastTile) {
        lastTile.focus();
      }
    } else {
      showDrawerView(drawer, 'categories');
    }
  });

  document.addEventListener('click', function (event) {
    var selectButton = event.target.closest('[data-color-select]');
    if (!selectButton) return;

    var drawer = selectButton.closest('[data-color-drawer]');
    var picker = getPickerFromDrawer(drawer);
    var input = document.getElementById(selectButton.getAttribute('data-controls'));
    var value = selectButton.getAttribute('data-value') || '';
    if (!drawer || !picker || !input || !value) return;

    var swatch = selectButton.getAttribute('data-swatch') || '';
    var priceVariantId = selectButton.getAttribute('data-price-variant-id') || '';

    input.value = value;
    if (priceVariantId) {
      input.setAttribute('data-price-variant-id', priceVariantId);
    } else {
      input.removeAttribute('data-price-variant-id');
    }
    input.dispatchEvent(new Event('change', { bubbles: true }));

    picker.querySelectorAll('[data-color-picker-summary-text]').forEach(function (el) {
      el.textContent = value;
    });
    picker.querySelectorAll('[data-color-picker-summary-swatch]').forEach(function (el) {
      el.style.backgroundImage = swatch ? 'url("' + swatch + '")' : '';
    });
    picker.querySelectorAll('.color-picker-summary__action').forEach(function (el) {
      el.textContent = 'Change';
    });
    picker.querySelectorAll('.color-picker-summary').forEach(function (el) {
      el.classList.remove('color-picker-summary--unselected');
    });

    picker.classList.remove('has-error');
    var opener = picker.querySelector('[data-color-drawer-open]');
    if (opener) opener.removeAttribute('aria-invalid');
    var pickerForm = picker.closest('form');
    if (pickerForm) clearValidationMessage(pickerForm);
    closeDrawer(drawer);
  });

  function getValidationMessageEl(form) {
    var container = form.querySelector('.product-form__buy-buttons') || form;
    var messageEl = form.querySelector('.product-form__validation-message');
    if (!messageEl) {
      messageEl = document.createElement('p');
      messageEl.className = 'product-form__validation-message';
      messageEl.hidden = true;
      messageEl.setAttribute('role', 'alert');
      if (container === form) form.appendChild(messageEl);
      else container.parentNode.insertBefore(messageEl, container);
    }
    return messageEl;
  }

  function showValidationMessage(form, text) {
    var messageEl = getValidationMessageEl(form);
    messageEl.textContent = text;
    messageEl.hidden = false;
  }

  function clearValidationMessage(form) {
    var messageEl = form.querySelector('.product-form__validation-message');
    if (messageEl) messageEl.hidden = true;
  }

  function clearCustomTextError(wrapper) {
    wrapper.classList.remove('has-error');
    var field = wrapper.querySelector('[data-custom-text-field]');
    if (field) {
      field.classList.remove('has-error');
      var input = field.querySelector('[data-custom-text-input]');
      if (input) input.removeAttribute('aria-invalid');
    }
  }

  function validateRequiredChoices(event, form) {
    var firstInvalid = null;
    form.querySelectorAll('[data-color-picker][data-required="true"]').forEach(function (picker) {
      if (firstInvalid) return;
      if (picker.closest('[hidden]')) return;
      var input = picker.querySelector('input[type="hidden"]');
      if (input && !input.disabled && !input.value) firstInvalid = picker;
    });

    if (!firstInvalid) {
      form.querySelectorAll('[data-custom-text-upsell]').forEach(function (wrapper) {
        if (firstInvalid) return;
        if (wrapper.closest('[hidden]')) return;

        var toggle = wrapper.querySelector('[data-custom-text-toggle]');
        var field = wrapper.querySelector('[data-custom-text-field]');
        var textInput = field ? field.querySelector('[data-custom-text-input]') : null;
        if (!textInput) return;
        // A block with no checkbox (required personalization) is always active.
        if (toggle && !toggle.checked) return;

        if (!textInput.value.trim()) {
          firstInvalid = field;
          wrapper.classList.add('has-error');
          field.classList.add('has-error');
        }
      });
    }

    if (firstInvalid) {
      event.preventDefault();
      event.stopImmediatePropagation();
      firstInvalid.classList.add('has-error');
      firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var buyButtons = form.querySelector('[data-validation-message]');
      var validationText = (buyButtons && buyButtons.dataset.validationMessage) || 'Please complete the required fields above before adding this item to your cart.';
      var focusTarget = firstInvalid.querySelector('[data-color-drawer-open], [data-custom-text-input]');
      if (focusTarget) {
        focusTarget.setAttribute('aria-invalid', 'true');
        focusTarget.focus({ preventScroll: true });
      }
      showValidationMessage(form, validationText);
      return false;
    }
    clearValidationMessage(form);
    return true;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.querySelector || !form.querySelector('[data-color-picker], [data-custom-text-upsell]')) return;
    syncAllTrackedBlocks(form);
    validateRequiredChoices(event, form);
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.product-form__add-button, buy-button');
    if (!button) return;

    syncAllTrackedBlocks();

    var form = button.closest('form');
    if (!form) return;

    if (!validateRequiredChoices(event, form)) return;
    {
      // Tag the main product's line item with a token shared with the paid upsell line item added
      // below, so the cart can keep both quantities in sync and treat them as a single unit.
      form.querySelectorAll('[data-custom-text-upsell][data-custom-text-mode="paid"]').forEach(function (wrapper) {
        if (wrapper.closest('[hidden]')) return;

        var toggle = wrapper.querySelector('[data-custom-text-toggle]');
        if (!toggle || !toggle.checked) return;

        var token = 'ctu_' + Date.now().toString(36) + Math.random().toString(36).slice(2);
        wrapper.setAttribute('data-customization-link', token);

        var linkInput = form.querySelector('input[name="properties[_customization_link]"]');
        if (!linkInput) {
          linkInput = document.createElement('input');
          linkInput.type = 'hidden';
          linkInput.name = 'properties[_customization_link]';
          form.appendChild(linkInput);
        }
        linkInput.value = token;
      });
    }
  }, true);

  document.addEventListener('change', function (event) {
    var toggle = event.target.closest('[data-custom-text-toggle]');
    if (!toggle) return;

    var wrapper = toggle.closest('[data-custom-text-upsell]');
    if (!wrapper) return;

    var field = wrapper.querySelector('[data-custom-text-field]');
    var textInput = field ? field.querySelector('[data-custom-text-input]') : null;

    if (field) field.hidden = !toggle.checked;
    if (textInput) {
      textInput.required = toggle.checked;
      if (!toggle.checked) textInput.value = '';
    }
    clearCustomTextError(wrapper);

    var form = wrapper.closest('form');
    if (form) clearValidationMessage(form);

    if (!toggle.checked) {
      // Clear any stale link from a previous customized add, so a later plain
      // copy added from this same form can't inherit its customization charge.
      wrapper.removeAttribute('data-customization-link');
      var linkInput = form && form.querySelector('input[name="properties[_customization_link]"]');
      if (linkInput) linkInput.value = '';
    }
  });

  document.addEventListener('input', function (event) {
    var textInput = event.target.closest('[data-custom-text-input]');
    if (!textInput) return;

    var wrapper = textInput.closest('[data-custom-text-upsell]');
    if (!wrapper || !textInput.value.trim()) return;

    clearCustomTextError(wrapper);

    var form = wrapper.closest('form');
    if (form) clearValidationMessage(form);
  });

  document.addEventListener('product:added', function (event) {
    if (!event.detail || !event.detail.productAdded) return;

    var addedQuantity = parseInt(event.detail.quantity, 10);
    if (!addedQuantity || addedQuantity < 1) addedQuantity = 1;

    document.querySelectorAll('[data-custom-text-upsell][data-custom-text-mode="paid"]').forEach(function (wrapper) {
      var toggle = wrapper.querySelector('[data-custom-text-toggle]');
      if (!toggle || !toggle.checked) return;

      var variantId = wrapper.getAttribute('data-upsell-variant-id');
      if (!variantId) return;

      var customizationLink = wrapper.getAttribute('data-customization-link');
      var addBody = { id: variantId, quantity: addedQuantity };
      if (customizationLink) addBody.properties = { _customization_link: customizationLink };

      fetch(`${window.routes.cartAddUrl}.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(addBody)
      }).then(function (response) {
        wrapper.removeAttribute('data-customization-link');

        if (!response.ok) {
          response.text().then(function (text) {
            console.error('Custom text upsell add-to-cart failed:', response.status, text);
          });
          return;
        }
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      });
    });
  });

  // Keeps a paid custom-text upsell's line item quantity tied to the product it belongs to, so
  // the two are always in sync and can only be removed together.
  function findLinkedCustomizationRows(triggerEl) {
    var row = triggerEl.closest('[data-hulkapps-lineitem]');
    if (!row || !row.hasAttribute('data-customization-link') || row.hasAttribute('data-customization-charge')) return null;

    var link = row.getAttribute('data-customization-link');
    var pairedRow = document.querySelector('[data-hulkapps-lineitem][data-customization-charge][data-customization-link="' + link + '"]');
    if (!pairedRow) return null;

    var mainKey = row.getAttribute('data-line-key');
    var chargeKey = pairedRow.getAttribute('data-line-key');
    if (!mainKey || !chargeKey) return null;

    return { mainKey: mainKey, chargeKey: chargeKey };
  }

  function syncCustomizationQuantity(quantity, keys) {
    var updates = {};
    updates[keys.mainKey] = quantity;
    updates[keys.chargeKey] = quantity;

    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(`${window.routes.cartUpdateUrl}.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (!response.ok) {
        response.text().then(function (text) {
          console.error('Customization quantity sync failed:', response.status, text);
        });
      }

      if (window.theme && window.theme.pageType === 'cart') {
        window.location.reload();
        return;
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-action="increase-quantity"], [data-action="decrease-quantity"]');
    if (!trigger) return;

    var keys = findLinkedCustomizationRows(trigger);
    if (!keys) return;

    var quantity = parseInt(trigger.getAttribute('data-quantity'), 10);
    if (isNaN(quantity) || quantity < 0) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    syncCustomizationQuantity(quantity, keys);
  }, true);

  document.addEventListener('change', function (event) {
    var input = event.target.closest('.quantity-selector:not(.quantity-selector--product) .quantity-selector__value');
    if (!input) return;

    var keys = findLinkedCustomizationRows(input);
    if (!keys) return;

    var quantity = parseInt(input.value, 10);
    if (isNaN(quantity) || quantity < 0) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    syncCustomizationQuantity(quantity, keys);
  }, true);

  document.addEventListener('product:added', function (event) {
    if (!event.detail || !event.detail.productAdded) return;

    document.querySelectorAll('[data-color-picker] input[data-price-variant-id]').forEach(function (input) {
      if (input.closest('[hidden]')) return;

      var variantId = input.getAttribute('data-price-variant-id');
      if (!variantId) return;

      fetch(`${window.routes.cartAddUrl}.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(function (response) {
        if (!response.ok) {
          response.text().then(function (text) {
            console.error('Color surcharge add-to-cart failed:', response.status, text);
          });
          return;
        }
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      });
    });
  });

  var TRACKED_BLOCK_TYPES = {
    'color-drawer': true,
    'view-all-colors': true,
    'color-category': true,
    'custom-text-upsell': true
  };

  function captureColorPickerState(container) {
    var state = {};
    if (!container) return state;

    container.querySelectorAll('[data-color-picker]').forEach(function (picker) {
      var input = picker.querySelector('input[type="hidden"]');
      if (!input || !input.value) return;

      var swatchEl = picker.querySelector('[data-color-picker-summary-swatch]');
      state[input.id] = {
        value: input.value,
        swatch: swatchEl ? swatchEl.style.backgroundImage : '',
        priceVariantId: input.getAttribute('data-price-variant-id') || ''
      };
    });

    return state;
  }

  function restoreColorPickerState(container, state) {
    if (!container) return;

    container.querySelectorAll('[data-color-picker]').forEach(function (picker) {
      var input = picker.querySelector('input[type="hidden"]');
      if (!input) return;

      var saved = state[input.id];
      if (!saved) return;

      input.value = saved.value;
      if (saved.priceVariantId) {
        input.setAttribute('data-price-variant-id', saved.priceVariantId);
      } else {
        input.removeAttribute('data-price-variant-id');
      }

      picker.querySelectorAll('[data-color-picker-summary-text]').forEach(function (el) {
        el.textContent = saved.value;
      });
      picker.querySelectorAll('[data-color-picker-summary-swatch]').forEach(function (el) {
        if (saved.swatch) el.style.backgroundImage = saved.swatch;
      });
      picker.querySelectorAll('.color-picker-summary__action').forEach(function (el) {
        el.textContent = 'Change';
      });
      picker.querySelectorAll('.color-picker-summary').forEach(function (el) {
        el.classList.remove('color-picker-summary--unselected');
      });
    });
  }

  function captureCustomTextState(container) {
    var state = {};
    if (!container) return state;

    container.querySelectorAll('[data-custom-text-upsell]').forEach(function (wrapper, index) {
      var toggle = wrapper.querySelector('[data-custom-text-toggle]');
      var textInput = wrapper.querySelector('[data-custom-text-input]');
      if (!toggle && !textInput) return;

      state[index] = {
        checked: !!(toggle && toggle.checked),
        value: textInput ? textInput.value : ''
      };
    });

    return state;
  }

  function restoreCustomTextState(container, state) {
    if (!container) return;

    container.querySelectorAll('[data-custom-text-upsell]').forEach(function (wrapper, index) {
      var saved = state[index];
      if (!saved) return;

      var toggle = wrapper.querySelector('[data-custom-text-toggle]');
      var field = wrapper.querySelector('[data-custom-text-field]');
      var textInput = wrapper.querySelector('[data-custom-text-input]');

      // No checkbox means required personalization: field stays visible/required regardless.
      if (toggle) {
        toggle.checked = saved.checked;
        if (field) field.hidden = !saved.checked;
        if (textInput) textInput.required = saved.checked;
      }
      if (textInput) textInput.value = saved.value;
    });
  }

  function syncTrackedBlocks(form, fragment) {
    var incomingAll = Array.prototype.slice.call(fragment.querySelectorAll('[data-block-id]'));

    incomingAll.forEach(function (incomingEl) {
      var blockType = incomingEl.getAttribute('data-block-type');
      if (!TRACKED_BLOCK_TYPES[blockType]) return;

      var blockId = incomingEl.getAttribute('data-block-id');
      var el = form.querySelector('[data-block-id="' + blockId + '"]');
      if (!el) return;

      var savedColorState = captureColorPickerState(el);
      var savedCustomTextState = captureCustomTextState(el);
      el.innerHTML = incomingEl.innerHTML;
      restoreColorPickerState(el, savedColorState);
      restoreCustomTextState(el, savedCustomTextState);

      if (incomingEl.hasAttribute('hidden')) {
        el.setAttribute('hidden', '');
      } else {
        el.removeAttribute('hidden');
      }
      syncBlockInputsDisabled(el);
    });
  }

  // Hidden blocks must not submit their line item properties, so disable their fields
  function syncBlockInputsDisabled(el) {
    var isHidden = el.hasAttribute('hidden');
    el.querySelectorAll('input, select, textarea').forEach(function (field) {
      if (isHidden) {
        if (!field.disabled) {
          field.disabled = true;
          field.setAttribute('data-disabled-by-hidden-block', '');
        }
      } else if (field.hasAttribute('data-disabled-by-hidden-block')) {
        field.disabled = false;
        field.removeAttribute('data-disabled-by-hidden-block');
      }
    });
  }

  function syncAllTrackedBlocks(root) {
    (root || document).querySelectorAll('[data-block-id][data-block-type]').forEach(function (el) {
      if (TRACKED_BLOCK_TYPES[el.getAttribute('data-block-type')]) syncBlockInputsDisabled(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { syncAllTrackedBlocks(); });
  } else {
    syncAllTrackedBlocks();
  }

  document.addEventListener('shopify:section:unload', function (event) {
    if (activeColorDrawer && event.target.contains(getPickerFromDrawer(activeColorDrawer))) closeDrawer(activeColorDrawer, false);
  });

  document.addEventListener('product:rerender', function (event) {
    var fragment = event.detail && event.detail.htmlFragment;
    var form = event.target;
    if (!fragment || !form || !form.querySelectorAll) return;

    if (activeColorDrawer && form.contains(getPickerFromDrawer(activeColorDrawer))) closeDrawer(activeColorDrawer, false);
    syncTrackedBlocks(form, fragment);
  }, true);
})();




